/* Veyno sale wording (real end: both discounts stop at this moment, Sun 8 Nov 2026 23:59:59 AEDT). Runs for everyone. */
(function () {
  var END = 1794142799000;
  function tick() {
    var left = END - Date.now(), over = left <= 0, when = left < 864e5 ? 'midnight tonight AEDT' : 'Sunday midnight AEDT';
    document.querySelectorAll('[data-vy-sale-end]').forEach(function (n) { n.textContent = n.getAttribute('data-vy-sale-end') + ' ' + when; });
    document.querySelectorAll('.ticker__item').forEach(function (n) {
      var t = n.textContent;
      if (!/Sale ends|Bundle Pack \$/.test(t)) return;
      if (over) { var d = n.nextElementSibling; if (d && d.classList.contains('ticker__divider')) d.remove(); n.remove(); return; }
      if (/Sale ends/.test(t)) { var el = n.querySelector('*') && n.children.length === 1 ? n.firstElementChild : n; el.textContent = 'Sale ends ' + when; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
  window.addEventListener('load', tick); setTimeout(tick, 1500); setInterval(tick, 60000);
})();
/* Veyno motion (ported from the Mosarai editorial set): photos unmask once from the bottom as they arrive,
   the hero settles on load. Respects prefers-reduced-motion. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { document.documentElement.classList.add('vy-no-motion'); return; }
  var targets = document.querySelectorAll('.vys__media, .vyst__media, .vyp__media, .vy-page__inner img');
  if (!('IntersectionObserver' in window)) { targets.forEach(function (t) { t.classList.add('is-revealed'); }); return; }
  targets.forEach(function (t) { t.setAttribute('data-vy-reveal', ''); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
  }, { threshold: 0.18 });
  targets.forEach(function (t) { io.observe(t); });
})();
